import { makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import logo from "../common/assets/logos/blue.png";
import VCERNButton from "../common/elements/VCERNButton";
import VCERNTypography from "../common/elements/VCERNTypography";
import constants from "../common/constants";
import { tosList } from "../common/data";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  logoBox: {
    padding: "40px",
    [theme.breakpoints.down("sm")]: {
      padding: "40px 0",
      display: "flex",
      justifyContent: "center",
    },
  },

  root: {
    margin: "0 auto",
    width: "60vw",
    [theme.breakpoints.down("sm")]: { width: "85vw" },
  },
  logo: { height: 100, width: 100 },

  listBox: { margin: "30px 0", alignSelf: "center" },
  list: { marginBottom: 10 },
  buttonBox: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    margin: "30px 0",
  },
}));

export default function Terms() {
  const classes = useStyles();
  const history = useHistory();
  const { type } = useSelector((state) => state);
  useEffect(() => {
    if (type == constants.USER_TYPE_MEMBER) {
      window.location =
        "https://www.websitepolicies.com/policies/view/dUIVuqQe";
    } else {
      window.location =
        "https://www.websitepolicies.com/policies/view/j3QS0AvY";
    }
  }, []);
  return null;

  return (
    <div>
      <div className={classes.logoBox}>
        <img src={logo} alt="logo" className={classes.logo} />
      </div>
      <div className={classes.root}>
        <VCERNTypography
          align="center"
          variant="h3"
          className={classes.logoText}
          value="Terms of Services"
        />

        <h2>Terms and conditions</h2>

        <p>
          These terms and conditions (“Agreement”) set forth the general terms
          and conditions of your use of the{" "}
          <a target="_blank" rel="nofollow" href="http://www.vcern.com">
            vcern.com
          </a>{" "}
          website (“Website”), “vCERN Fund” mobile application (“Mobile
          Application”) and any of their related products and services
          (collectively, “Services”). This Agreement is legally binding between
          you (“User”, “you” or “your”) and vCERN LLC (doing business as “vCERN
          Fund”, “we”, “us” or “our”). If you are entering into this agreement
          on behalf of a business or other legal entity, you represent that you
          have the authority to bind such entity to this agreement, in which
          case the terms “User”, “you” or “your” shall refer to such entity. If
          you do not have such authority, or if you do not agree with the terms
          of this agreement, you must not accept this agreement and may not
          access and use the Services. By accessing and using the Services, you
          acknowledge that you have read, understood, and agree to be bound by
          the terms of this Agreement. You acknowledge that this Agreement is a
          contract between you and vCERN Fund, even though it is electronic and
          is not physically signed by you, and it governs your use of the
          Services.
        </p>
        <h2>Accounts and membership</h2>
        <p>
          You must be at least 18 years of age to use the Services. By using the
          Services and by agreeing to this Agreement you warrant and represent
          that you are at least 18 years of age. If you create an account on the
          Services, you are responsible for maintaining the security of your
          account and you are fully responsible for all activities that occur
          under the account and any other actions taken in connection with it.
          We may, but have no obligation to, monitor and review new accounts
          before you may sign in and start using the Services. Providing false
          contact information of any kind may result in the termination of your
          account. You must immediately notify us of any unauthorized uses of
          your account or any other breaches of security. We will not be liable
          for any acts or omissions by you, including any damages of any kind
          incurred as a result of such acts or omissions. We may suspend,
          disable, or delete your account (or any part thereof) if we determine
          that you have violated any provision of this Agreement or that your
          conduct or content would tend to damage our reputation and goodwill.
          If we delete your account for the foregoing reasons, you may not
          re-register for our Services. We may block your email address and
          Internet protocol address to prevent further registration.
        </p>
        <h2>Billing and payments</h2>
        <p>
          You shall pay all fees or charges to your account in accordance with
          the fees, charges, and billing terms in effect at the time a fee or
          charge is due and payable. If auto-renewal is enabled for the Services
          you have subscribed for, you will be charged automatically in
          accordance with the term you selected. If, in our judgment, your
          purchase constitutes a high-risk transaction, we will require you to
          provide us with a copy of your valid government-issued photo
          identification, and possibly a copy of a recent bank statement for the
          credit or debit card used for the purchase. We reserve the right to
          change products and product pricing at any time. We also reserve the
          right to refuse any order you place with us. We may, in our sole
          discretion, limit or cancel quantities purchased per person, per
          household or per order. These restrictions may include orders placed
          by or under the same customer account, the same credit card, and/or
          orders that use the same billing and/or shipping address. In the event
          that we make a change to or cancel an order, we may attempt to notify
          you by contacting the e-mail and/or billing address/phone number
          provided at the time the order was made.
        </p>
        <h2>Accuracy of information</h2>
        <p>
          Occasionally there may be information on the Services that contains
          typographical errors, inaccuracies or omissions that may relate to
          pricing, availability, promotions and offers. We reserve the right to
          correct any errors, inaccuracies or omissions, and to change or update
          information or cancel orders if any information on the Services or
          Services is inaccurate at any time without prior notice (including
          after you have submitted your order). We undertake no obligation to
          update, amend or clarify information on the Services including,
          without limitation, pricing information, except as required by law. No
          specified update or refresh date applied on the Services should be
          taken to indicate that all information on the Services or Services has
          been modified or updated.
        </p>
        <h2>Links to other resources</h2>
        <p>
          Although the Services may link to other resources (such as websites,
          mobile applications, etc.), we are not, directly or indirectly,
          implying any approval, association, sponsorship, endorsement, or
          affiliation with any linked resource, unless specifically stated
          herein. We are not responsible for examining or evaluating, and we do
          not warrant the offerings of, any businesses or individuals or the
          content of their resources. We do not assume any responsibility or
          liability for the actions, products, services, and content of any
          other third parties. You should carefully review the legal statements
          and other conditions of use of any resource which you access through a
          link on the Services. Your linking to any other off-site resources is
          at your own risk.
        </p>
        <h2>Key Terms Definition</h2>
        <p>
          Here and after Organization refers to any organizations including but
          not limited to non profit organizations, for profit organizations,
          cultural associations, individuals, or businesses that open up an
          account with vCERN to create pool(s) of people who agree to contribute
          toward each other funeral expenses or any other predefined life event.{" "}
          <br />
          Membership refers to an individual adhesion to an organization pool of
          qualified members after a 3 month wait period ??
        </p>
        <h2>General Provisions</h2>
        <p>
          By signing up to vCERN, you agree to: a) that you are between the age
          of 1 and 70 years of age, b) to have your membership managed by the
          organization that you signed under, c) to be placed in a pool with
          other qualified members from that organization, d) to pay a yearly
          subscription fee to use vCERN platform, f) to observe a ninety (90)
          days waiting period from the time you register to become a qualified
          member and have member’s privileges, g) to voluntarily contribute an
          amount that would be determined by dividing the payout amount,
          currently set at $20,000 by the number of people in your pool every
          time a qualified member passes away in your pool, i) to keep your
          password secure; vCERN cannot and will not be liable for any loss or
          damage from your failure to maintain the security of your Account and
          password, j) provide your full legal name, current address, phone
          number, a valid email address, and any additional information
          indicated as required.
          <br />
          Your name should be given as it is written on your official documents
          (No Abbreviations). <br />
          No justification or name change shall be accepted after a death has
          been announced. <br />
          You acknowledge that vCERN will use the phone number and email address
          you provided as the primary method for communication.
          <br /> It is your responsibility to keep your contact information
          updated and your password secure!.
        </p>
        <h2>Payments and Fees</h2>
        <p>
          By signing up for our Services, you are expressly agreeing that we are
          authorized to charge you a yearly membership fee of $19.99, any other
          fees for additional services you may purchase, and any applicable
          taxes and fees in connection with your use of our Services to the
          credit card on file or other payment method accepted by vCERN LLC that
          you provided during registration. The Membership Fee will be charged
          to the payment method on file on a recurring and periodic annual
          basis. If your Payment Method expires and you do not edit your Payment
          Method information or cancel your account, you authorize us to
          continue billing, and you will remain responsible for any uncollected
          amounts.
        </p>
        <p>
          At the end of each Billing Cycle, your Membership will automatically
          renew under the exact same conditions unless you cancel it or vCERN
          LLC cancels it. You may cancel your Membership renewal through your
          online account management page.{" "}
        </p>
        <p>
          The other part of the Service includes your agreement to a voluntary
          monetary contribution when a member dies on each pool that you belong
          to (“Contribution”). Your credit card on file will be automatically
          charged for your contribution/donation.{" "}
        </p>
        <p>
          Your contribution to replenish the pool fund will be recalculated each
          time a member passes away in your pool and determined by dividing the
          number of active members in that pool by the payout amount, currently
          set at $20,000 (on a per event basis).
        </p>
        <p>
          Your first contribution will be charged on your credit card (payment
          method) on file when your membership is activated after the initial 90
          days waiting period is over to prefund the pool. After this initial
          charge, you will be charged only when a pool member passes away to
          replenish the pool.{" "}
        </p>
        <p>
          In some cases, an organization can decide to charge an administrative
          fee to its pool members. This fee would be determined by the
          organization. By agreeing to this agreement, you agree to be charged
          such fee{" "}
        </p>
        <p>
          A valid payment method, including but not excluded to credit card or
          debit card is required to process the payment for your Subscription
          and Contribution or any other associated fees. You shall provide vCERN
          LLC with accurate and complete billing information including full
          name, address, state, zip code, telephone number, and a valid payment
          method information. By submitting such payment information, you
          automatically authorize vCERN LLC to charge all Subscription fees and
          Contributions incurred through your account to any such payment
          instruments.
        </p>
        <p>
          Should automatic billing fail to occur for any reason, vCERN LLC will
          issue an electronic invoice indicating that you must proceed manually,
          within a certain deadline date, with the full payment corresponding to
          the billing period as indicated on the invoice.
        </p>
        <p>
          Transaction Fees and Additional Fees will be charged from time to time
          at vCERN LLC’s discretion. Users have fourteen (14) days to bring up
          and settle any issues with or relating to charges in their accounts.
          If the dispute is not resolved within 14 days, either Party may demand
          arbitration administered by the American Arbitration Association (AAA)
          under its applicable rules. Arbitrators appointed in such arbitration
          proceedings must be impartial and independent, as set forth under the
          rules of the AAA. Nothing contained herein shall prevent a Party from
          seeking temporary injunctive relief with respect to a dispute or to
          enforce the contractual obligation to compel arbitration of any
          dispute. Arbitration shall be held in Cook County Illinois.
        </p>
        <p>
          Because we prefer to resolve our issues with you directly, you agree
          to arbitrate with vCERN LLC only in your individual capacity, not as a
          representative or member of a class. As such, your claims may not be
          joined with any other claims and there shall be no authority for any
          dispute to be arbitrated on a class action basis or brought by a
          purported class representative.
        </p>
        <h2>Fee Changes</h2>
        <p>
          vCERN LLC, in its sole discretion and at any time, may modify the
          Membership fees for the Service and the voluntary contribution. Any
          Membership fee change will become effective at the end of the current
          Billing Cycle. The Contribution will become effective when the next
          event occurs in your pool.{" "}
        </p>
        <p>
          vCERN LLC will provide you with a reasonable prior notice of any
          change in Subscription fees and voluntary contribution to give you an
          opportunity to terminate your Subscription before such changes become
          effective.
        </p>
        <p>
          Your continued use of the Service after the fee changes come into
          effect constitutes your agreement to pay the modified Subscription fee
          amount.
        </p>
        <h2>Refund</h2>
        <p>
          vCERN LLC does not provide a refund for membership fee except for
          contributions paid in advance and when required by law, paid
          Membership fees are non-refundable.
        </p>
        <h2>Unpaid Amounts</h2>
        <p>
          In order to sustain our Service, it is important that each user of the
          Service honor the voluntary payment to which the user agreed. You will
          remain liable to your organization for all such amounts and all costs
          we incur in connection with the collection of these amounts,
          including, without limitation, collection agency fees, reasonable
          attorney’s fees, and arbitration or court costs.
        </p>
        <h2>Accounts</h2>
        <p>
          If you are under the age of 18, then you are not permitted to register
          to our Service or use any feature or other part of our services that
          require registration. Except as a minor dependent designated on the
          member’s registration or subscription.
        </p>
        <p>
          When you create an account with us and at all times, you certify that
          you are above the age of 18, and that the information you provide us
          is accurate, complete, and current.. Inaccurate, incomplete, or
          obsolete information may result in the immediate termination of your
          account on the Service and denial of benefits.
        </p>
        <p>
          Please keep your personal information updated and confidential.
          Failure to keep your personal information updated constitutes a breach
          of this agreement. You are responsible for maintaining the
          confidentiality of your account and password, including but not
          limited to the restriction of access to your computer, phone and/or
          account. You agree to accept responsibility for any and all activities
          or actions that occur under your account and/or password, whether your
          password is with our Service or a third-party service. You must notify
          us immediately upon becoming aware of any breach of security or
          unauthorized use of your account.
        </p>
        <p>
          As the person signing up to vCERN Services, you will be the
          contracting party (“Account Holder”) for the purpose of our Terms and
          Conditions and will be the person who is authorized to use any
          corresponding account we may provide to the Account Holder in
          connection with the Service.{" "}
        </p>
        <p>
          If you are signing up for the Service on behalf of your relative,
          organization, or employer, your relative, organization and/or employer
          shall be the Account Holder. If you are signing up for the Service on
          behalf of your relative, organization, or employer, then you represent
          and warrant that you have the authority to bind your relative,
          organization, and/or employer to vCERN Terms and Conditions as an
          agent.{" "}
        </p>
        <p>
          You may not use as a username the name of another person or entity or
          that is not lawfully available for use, a name or trademark that is
          subject to any rights of another person or entity other than you,
          without appropriate authorization. You may not use as a username any
          name that is offensive, vulgar or obscene.
        </p>
        <p>
          We reserve the right to immediately terminate or restrict your account
          or your use of our Service or access to our content at any time,
          without notice or liability, if vCERN LLC determines in its sole
          discretion that you have breached these Terms and Conditions, violated
          any law, rule, or regulation, or engaged in other inappropriate
          conduct, or for any other business reason.
        </p>
        <h2>Benefits</h2>
        <p>
          vCERN pledges to group you with other members of the organization that
          you signed in under that are committed to assisting designated persons
          by way of voluntary contribution upon the death of a member of the
          pool. The money will come directly from member contributions for a
          total of $20,000 (U.S. dollars) to cover funeral expenses. The amount
          could be revised in the future for higher or lower payouts.{" "}
        </p>
        <p>
          A vCERN beneficiary is a person designated by a vCERN member to
          receive the money to cover expenses related to their funeral
          arrangements.{" "}
        </p>
        <p>
          Any member’s death must be reported to vCERN within three (3) months,
          and the necessary documents must be submitted within the same three
          (3) month period to receive the payout. Any death reported after, or
          if the documents are not submitted within that period, the member’s
          payout will be forfeited.
        </p>
        <h2>Terminal Illness Clause</h2>
        <p>
          vCERN does not cover anyone with a diagnosed terminal illness at the
          time of the application. By signing up, you affirm that you do not
          have any terminal illness. You agree to give vCERN the permission to
          access your personal medical record and to communicate with your
          healthcare provider or any authority in order to confirm that you were
          not terminally ill when you signed up for the Service.
        </p>
        <h2>Suicide Clause</h2>
        <p>
          vCERN will not cover members who died by committing suicide within the
          first two (2) years of them signing up for our Service.
        </p>
        <h2>Required Conditions for Benefits</h2>
        <p>
          A beneficiary needs to provide the following in case of a member’s
          death in the United States of America (“USA”):
          <br />
          1) Death Certificate
          <br />
          2) For members that have a valid membership for less than a year, a
          doctor's note stating that the deceased was unaware of any terminal
          condition prior to the time they signed up for our Service may be
          required. <br />
          3) Funeral Home Invoice
          <br />
          4) Membership Number <br />
          5) ID or Passport of the Deceased <br />
          6) Completed W9 Form
        </p>
        <p>
          In case of a member’s death outside of the United States of America,
          in addition to the six documents required above, a beneficiary should
          provide: <br />
          1) Social Security of the Deceased
          <br />
          2) Valid U.S. Identification Card (“ID”)
          <br />
          3) Copy of the passport with the Entry Visa into the Country of death
          <br />
          4) Copy of the transport ticket used during the trip when the member
          passed away. <br />
          5) The eligibility of the benefit shall be applied only to members who
          have been in the country of death for no more than three (3) months.
        </p>
        <h2>Returning Members</h2>
        <p>
          Any member who voluntarily cancels its vCERN subscription and decides
          to rejoin at a later time: a) shall observe a waiting period of 6
          months, b) will be issued a new account, c) and could be asked, at
          vCERN discretion, to answer some health related questions.
        </p>
        <h2>Prohibited uses</h2>
        <p>
          In addition to other terms as set forth in the Agreement, you are
          prohibited from using the Services or Content: (a) for any unlawful
          purpose; (b) to solicit others to perform or participate in any
          unlawful acts; (c) to violate any international, federal, provincial
          or state regulations, rules, laws, or local ordinances; (d) to
          infringe upon or violate our intellectual property rights or the
          intellectual property rights of others; (e) to harass, abuse, insult,
          harm, defame, slander, disparage, intimidate, or discriminate based on
          gender, sexual orientation, religion, ethnicity, race, age, national
          origin, or disability; (f) to submit false or misleading information;
          (g) to upload or transmit viruses or any other type of malicious code
          that will or may be used in any way that will affect the functionality
          or operation of the Services, third party products and services, or
          the Internet; (h) to spam, phish, pharm, pretext, spider, crawl, or
          scrape; (i) for any obscene or immoral purpose; or (j) to interfere
          with or circumvent the security features of the Services, third party
          products and services, or the Internet. We reserve the right to
          terminate your use of the Services for violating any of the prohibited
          uses.
        </p>
        <h2>Intellectual property rights</h2>
        <p>
          “Intellectual Property Rights” means all present and future rights
          conferred by statute, common law or equity in or in relation to any
          copyright and related rights, trademarks, designs, patents,
          inventions, goodwill and the right to sue for passing off, rights to
          inventions, rights to use, and all other intellectual property rights,
          in each case whether registered or unregistered and including all
          applications and rights to apply for and be granted, rights to claim
          priority from, such rights and all similar or equivalent rights or
          forms of protection and any other results of intellectual activity
          which subsist or will subsist now or in the future in any part of the
          world. This Agreement does not transfer to you any intellectual
          property owned by vCERN Fund or third parties, and all rights, titles,
          and interests in and to such property will remain (as between the
          parties) solely with vCERN Fund. All trademarks, service marks,
          graphics and logos used in connection with the Services, are
          trademarks or registered trademarks of vCERN Fund or its licensors.
          Other trademarks, service marks, graphics and logos used in connection
          with the Services may be the trademarks of other third parties. Your
          use of the Services grants you no right or license to reproduce or
          otherwise use any of vCERN Fund or third party trademarks.
        </p>
        <h2>Disclaimer of warranty</h2>
        <p>
          You agree that such Service is provided on an “as is” and “as
          available” basis and that your use of the Services is solely at your
          own risk. We expressly disclaim all warranties of any kind, whether
          express or implied, including but not limited to the implied
          warranties of merchantability, fitness for a particular purpose and
          non-infringement. We make no warranty that the Services will meet your
          requirements, or that the Service will be uninterrupted, timely,
          secure, or error-free; nor do we make any warranty as to the results
          that may be obtained from the use of the Service or as to the accuracy
          or reliability of any information obtained through the Service or that
          defects in the Service will be corrected. You understand and agree
          that any material and/or data downloaded or otherwise obtained through
          the use of Service is done at your own discretion and risk and that
          you will be solely responsible for any damage or loss of data that
          results from the download of such material and/or data. We make no
          warranty regarding any goods or services purchased or obtained through
          the Service or any transactions entered into through the Service
          unless stated otherwise. No advice or information, whether oral or
          written, obtained by you from us or through the Service shall create
          any warranty not expressly made herein.
        </p>
        <h2>Limitation of liability</h2>
        <p>
          To the fullest extent permitted by applicable law, in no event will
          vCERN Fund, its affiliates, directors, officers, employees, agents,
          suppliers or licensors be liable to any person for any indirect,
          incidental, special, punitive, cover or consequential damages
          (including, without limitation, damages for lost profits, revenue,
          sales, goodwill, use of content, impact on business, business
          interruption, loss of anticipated savings, loss of business
          opportunity) however caused, under any theory of liability, including,
          without limitation, contract, tort, warranty, breach of statutory
          duty, negligence or otherwise, even if the liable party has been
          advised as to the possibility of such damages or could have foreseen
          such damages. To the maximum extent permitted by applicable law, the
          aggregate liability of vCERN Fund and its affiliates, officers,
          employees, agents, suppliers and licensors relating to the services
          will be limited to an amount greater of one dollar or any amounts
          actually paid in cash by you to vCERN Fund for the prior one month
          period prior to the first event or occurrence giving rise to such
          liability. The limitations and exclusions also apply if this remedy
          does not fully compensate you for any losses or fails of its essential
          purpose.
        </p>
        <h2>Indemnification</h2>
        <p>
          You agree to indemnify and hold vCERN Fund and its affiliates,
          directors, officers, employees, agents, suppliers and licensors
          harmless from and against any liabilities, losses, damages or costs,
          including reasonable attorneys’ fees, incurred in connection with or
          arising from any third party allegations, claims, actions, disputes,
          or demands asserted against any of them as a result of or relating to
          your Content, your use of the Services or any willful misconduct on
          your part.
        </p>
        <h2>Severability</h2>
        <p>
          All rights and restrictions contained in this Agreement may be
          exercised and shall be applicable and binding only to the extent that
          they do not violate any applicable laws and are intended to be limited
          to the extent necessary so that they will not render this Agreement
          illegal, invalid or unenforceable. If any provision or portion of any
          provision of this Agreement shall be held to be illegal, invalid or
          unenforceable by a court of competent jurisdiction, it is the
          intention of the parties that the remaining provisions or portions
          thereof shall constitute their agreement with respect to the subject
          matter hereof, and all such remaining provisions or portions thereof
          shall remain in full force and effect.
        </p>
        <h2>Dispute resolution</h2>
        <p>
          The formation, interpretation, and performance of this Agreement and
          any disputes arising out of it shall be governed by the substantive
          and procedural laws of Illinois, United States without regard to its
          rules on conflicts or choice of law and, to the extent applicable, the
          laws of United States. The exclusive jurisdiction and venue for
          actions related to the subject matter hereof shall be the courts
          located in Illinois, United States, and you hereby submit to the
          personal jurisdiction of such courts. You hereby waive any right to a
          jury trial in any proceeding arising out of or related to this
          Agreement. The United Nations Convention on Contracts for the
          International Sale of Goods does not apply to this Agreement.
        </p>
        <h2>Changes and amendments</h2>
        <p>
          We reserve the right to modify this Agreement or its terms related to
          the Services at any time at our discretion. When we do, we will revise
          the updated date at the bottom of this page, send you an email to
          notify you. We may also provide notice to you in other ways at our
          discretion, such as through the contact information you have provided.
        </p>
        <p>
          An updated version of this Agreement will be effective immediately
          upon the posting of the revised Agreement unless otherwise specified.
          Your continued use of the Services after the effective date of the
          revised Agreement (or such other act specified at that time) will
          constitute your consent to those changes.
        </p>
        <h2>Acceptance of these terms</h2>
        <p>
          You acknowledge that you have read this Agreement and agree to all its
          terms and conditions. By accessing and using the Services you agree to
          be bound by this Agreement. If you do not agree to abide by the terms
          of this Agreement, you are not authorized to access or use the
          Services.
        </p>
        <h2>Contacting us</h2>
        <p>
          If you have any questions, concerns, or complaints regarding this
          Agreement, we encourage you to contact us using the details below:
        </p>
        <p>support@vcern.com</p>
        <p>This document was last updated on August 13, 2021</p>

        {/* <div className={classes.buttonBox}>
                    <VCERNButton fullWidth value="Decline" color="secondary" width="46%" onClick={() => history.push('/login')} />
                    <VCERNButton fullWidth value="Accept" width="46%" onClick={() => history.push('/login')} />
                </div> */}
      </div>
    </div>
  );
}
